// src/components/Navbar.js
import React, { useState } from 'react';
import '../css/Navbar.css';

const Navbar = () => {
  // Track if mobile menu is open
  const [menuOpen, setMenuOpen] = useState(false);

  // OPTIONAL: track "active link" so we can highlight the current page
  const [activeLink, setActiveLink] = useState('#hero');

  // Toggle menu for mobile
  const handleToggle = () => {
    setMenuOpen(!menuOpen);
  };

  // Close menu on link click
  const handleLinkClick = (link) => {
    setMenuOpen(false);
    setActiveLink(link); // set which link is active
  };

  // Nav items you can add or remove as needed
  const navItems = [
    { id: '#hero', label: 'Home' },
    { id: '#experience', label: 'Experience' },
    { id: '#projects', label: 'Projects' },
    { id: '#contact', label: 'Contact' },
    // Navbar navItems array
{ id:'#techstack', label:'Stack'},
{ id:'#testimonials', label:'Testimonials'},
{ id:'#blog', label:'Blog'},
{ id:'#community', label:'Open‑Source'},

  ];

  return (
    <nav className="navbar">
      <div className="nav-logo">
        {/* Example brand name or logo */}
        <span className="nav-logo-text">OZ AI</span>
      </div>

      {/* Hamburger (visible on mobile) */}
      <button 
        className="nav-toggle" 
        onClick={handleToggle}
        aria-label="Toggle navigation"
      >
        {menuOpen ? '✕' : '☰'}
      </button>

      {/* Nav Links */}
      <ul className={`nav-links ${menuOpen ? 'open' : ''}`}>
        {navItems.map((item) => (
          <li 
            key={item.id} 
            className={activeLink === item.id ? 'active' : ''}
          >
            <a 
              href={item.id} 
              onClick={() => handleLinkClick(item.id)}
            >
              {item.label}
            </a>
          </li>
        ))}
      </ul>
    </nav>
  );
};

export default Navbar;
